import FrequentlyUsedOrderSearchCriteriaDto from "@/dto/FrequentlyUsedOrderSearchCriteriaDto";
import {
    GetFrequentlyOrderSearchCriteriaListParams,
    batchUpdateFrequentlyOrderSearchCriteria,
    getFrequentlyOrderSearchCriterionList,
} from "@/services/api/frequentlyOrderSearchCriteria";
import { getNeedUpdateMoveDataSource } from "@/utils/Array";
import { observable, makeObservable, actionBound } from "mobx";
import { createContext, useContext } from "react";

/**
 * 快捷搜索管理
 */
export default class FrequentlyOrderSearchCriteriaStore {
    constructor() {
        makeObservable(this, {
            frequentlyOrderSearchCriterions: observable,
            loading: observable,
            loadFrequentlyOrderSearchCriterion: actionBound,
            updateOrderSearchCriteria: actionBound,
            deleteOrderSearchCriteria: actionBound,
            handleSort: actionBound,
            clearFrequentlyOrderSearchCriterions: actionBound,
        });
    }

    frequentlyOrderSearchCriterions: FrequentlyUsedOrderSearchCriteriaDto[] = [];

    loading = false;

    async loadFrequentlyOrderSearchCriterion(params: GetFrequentlyOrderSearchCriteriaListParams) {
        this.loading = true;

        try {
            const data = await getFrequentlyOrderSearchCriterionList(params);

            data.sort((a, b) => {
                return (a.sortedIndex || -1) - (b.sortedIndex || -1);
            });

            this.frequentlyOrderSearchCriterions = data;
        } finally {
            this.loading = false;
        }
    }

    updateOrderSearchCriteria(id: number, prop: FrequentlyUsedOrderSearchCriteriaDto) {
        const frequentlyOrderSearchCriteriaIndex = this.frequentlyOrderSearchCriterions.findIndex((it) => it.id === id);

        if (frequentlyOrderSearchCriteriaIndex === -1) {
            this.frequentlyOrderSearchCriterions.push(prop);

            return;
        }

        const frequentlyOrderSearchCriteria = this.frequentlyOrderSearchCriterions[frequentlyOrderSearchCriteriaIndex];

        this.frequentlyOrderSearchCriterions[frequentlyOrderSearchCriteriaIndex] = Object.assign(
            {},
            frequentlyOrderSearchCriteria,
            prop,
        );
    }

    deleteOrderSearchCriteria(id: number) {
        const frequentlyOrderSearchCriteriaIndex = this.frequentlyOrderSearchCriterions.findIndex((it) => it.id === id);

        if (frequentlyOrderSearchCriteriaIndex === -1) return;

        const newFrequentlyOrderSearchCriterion = [...this.frequentlyOrderSearchCriterions];

        newFrequentlyOrderSearchCriterion.splice(frequentlyOrderSearchCriteriaIndex, 1);

        this.frequentlyOrderSearchCriterions = newFrequentlyOrderSearchCriterion;
    }

    async handleSort(newSortedDataSource: FrequentlyUsedOrderSearchCriteriaDto[]) {
        try {
            this.loading = true;

            const needUpdateMovedDataSource = getNeedUpdateMoveDataSource(
                this.frequentlyOrderSearchCriterions,
                newSortedDataSource,
                {
                    idKey: "id",
                    indexKey: "sortedIndex",
                },
            );

            if (!needUpdateMovedDataSource.length) {
                return;
            }

            await batchUpdateFrequentlyOrderSearchCriteria(needUpdateMovedDataSource);

            this.frequentlyOrderSearchCriterions = newSortedDataSource;
        } finally {
            this.loading = false;
        }
    }

    clearFrequentlyOrderSearchCriterions() {
        this.frequentlyOrderSearchCriterions = [];
    }
}

export const FrequentlyOrderSearchCriteriaStoreContext = createContext<FrequentlyOrderSearchCriteriaStore>(undefined);

export const useFrequentlyOrderSearchCriteriaStore = () => {
    return useContext(FrequentlyOrderSearchCriteriaStoreContext);
};
